const SAVE_BEDRIJF_FILTER = 'SAVE_BEDRIJF_FILTER';
const RESET_BEDRIJF_FILTER = 'RESET_BEDRIJF_FILTER';

const initialState = () => ({
    bedrijfFilter: {
        zoekstring: '',
    },
});

const module = {
    state: initialState(),
    mutations: {
        [SAVE_BEDRIJF_FILTER] (state, payload) {
            state.bedrijfFilter = payload;
        },
        [RESET_BEDRIJF_FILTER] (s) {
            const initial = initialState();
            Object.keys(initial).forEach((key) => { s[key] = initial[key]; });
        },
    },
    actions: {
        saveBedrijfFilter ({ commit }, payload) {
            commit(SAVE_BEDRIJF_FILTER, payload);
        },
        resetBedrijfFilter ({ commit }, payload) {
            commit(RESET_BEDRIJF_FILTER, payload);
        },
    },
    getters: {
        bedrijfFilter: state => state.bedrijfFilter,
    },
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/bedrijf.js